var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 326.155,
    height: 315.434,
    viewBox: "0 0 326.155 315.434",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2458",
    "data-name": "\\uADF8\\uB8F9 2458",
    transform: "translate(-436.155 -488.819)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stethoscope-svgrepo-com",
    transform: "translate(595.212 790.561) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4228",
    "data-name": "\\uD328\\uC2A4 4228",
    d: "M100.287,199.858c42.124-5.629,75.23-39.037,76.32-79.285V46.129A12.683,12.683,0,0,0,163.957,33.48H134.845c-.042-.012-.093,23.243-.1,23.243l16.7.011-.076,63.839c0,30.262-28.385,54.894-63.126,54.894-34.68,0-63.126-24.633-63.126-54.894V92.7H0v27.813C0,160.76,32.5,194.229,75.109,199.8Z",
    transform: "translate(0 -32.76)",
    fill: "#28ffff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4231",
    "data-name": "\\uD328\\uC2A4 4231",
    d: "M17.095,31.679A43.4,43.4,0,0,1,54.506,11a12.028,12.028,0,1,1,0,24.056,19.51,19.51,0,0,0-16.838,9.125,16.871,16.871,0,0,0-.83,16.413L75.85,124.17c.178.237.3.533.474.77A19.029,19.029,0,0,0,93.7,135.191h.119a19.29,19.29,0,0,0,17.372-10.073,5.41,5.41,0,0,1,.474-.77L151.622,60.83a16.942,16.942,0,0,0-.652-16.531,19.382,19.382,0,0,0-16.9-9.243A12.028,12.028,0,0,1,134.013,11a43.282,43.282,0,0,1,37.53,20.916,40.868,40.868,0,0,1,1.126,40.528,5.408,5.408,0,0,1-.474.77l-40.02,63.7a42.79,42.79,0,0,1-26.206,20.8v84.552c0,8.117,11.8,17.183,28.7,17.183s28.121-8.414,28.121-16.531V166.621l25.245-8.8V242.91a3.3,3.3,0,0,1,0,.765C186.964,266.013,163.776,283.5,134.9,283.5c-29.645,0-52.826-18.131-52.826-41.3V157.825a43.224,43.224,0,0,1-26.858-21.331L16.146,72.858c-.178-.237-.3-.533-.474-.77a40.79,40.79,0,0,1,1.423-40.409Z",
    transform: "translate(431.155 477.819)",
    fill: "#28ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4232",
    "data-name": "\\uD328\\uC2A4 4232",
    d: "M17.095,31.679A43.4,43.4,0,0,1,54.506,11a12.028,12.028,0,1,1,0,24.056,19.51,19.51,0,0,0-16.838,9.125,16.871,16.871,0,0,0-.83,16.413L75.85,124.17c.178.237.3.533.474.77A19.029,19.029,0,0,0,93.7,135.191h.119a19.29,19.29,0,0,0,17.372-10.073,5.41,5.41,0,0,1,.474-.77L151.622,60.83a16.942,16.942,0,0,0-.652-16.531,19.382,19.382,0,0,0-16.9-9.243A12.028,12.028,0,0,1,134.013,11a43.282,43.282,0,0,1,37.53,20.916,40.868,40.868,0,0,1,1.126,40.528,5.408,5.408,0,0,1-.474.77l-40.02,63.7a42.79,42.79,0,0,1-26.206,20.8v84.552c0,8.117,11.8,17.183,28.7,17.183s28.121-8.414,28.121-16.531V166.621l25.245,6.442V242.91a3.3,3.3,0,0,1,0,.765C186.964,266.013,163.776,283.5,134.9,283.5c-29.645,0-52.826-18.131-52.826-41.3V157.825a43.224,43.224,0,0,1-26.858-21.331L16.146,72.858c-.178-.237-.3-.533-.474-.77a40.79,40.79,0,0,1,1.423-40.409Z",
    transform: "translate(425.155 477.819)",
    fill: "#3c3c3c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "stethoscope-svgrepo-com-2",
    "data-name": "stethoscope-svgrepo-com",
    transform: "translate(587.212 790.561) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4228-2",
    "data-name": "\\uD328\\uC2A4 4228",
    d: "M100.287,199.858c42.124-5.629,75.23-39.037,76.32-79.285V46.129A12.683,12.683,0,0,0,163.957,33.48H134.845c-.042-.012-.053,25.238-.061,25.238h16.583v61.855c0,30.262-28.385,54.894-63.126,54.894-34.68,0-63.126-24.633-63.126-54.894V92.7H0v27.813C0,160.76,32.5,194.229,75.109,199.8Z",
    transform: "translate(0 -32.76)",
    fill: "#3c3c3c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_489",
    "data-name": "\\uD0C0\\uC6D0 489",
    transform: "translate(604.155 747.253)",
    fill: "none",
    stroke: "#3c3c3c",
    strokeWidth: 15
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.5,
    r: 28.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.5,
    r: 21,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2435",
    "data-name": "\\uADF8\\uB8F9 2435",
    transform: "translate(-136.26 -10.719)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3964",
    "data-name": "\\uD328\\uC2A4 3964",
    d: "M53.66,63.25H35.589a4.518,4.518,0,0,1-4.518-4.518V45.178H17.518A4.518,4.518,0,0,1,13,40.66V22.589a4.518,4.518,0,0,1,4.518-4.518H31.071V4.518A4.518,4.518,0,0,1,35.589,0H53.66a4.518,4.518,0,0,1,4.518,4.518V18.071H71.732a4.518,4.518,0,0,1,4.518,4.518V40.66a4.518,4.518,0,0,1-4.518,4.518H58.178V58.732A4.518,4.518,0,0,1,53.66,63.25ZM40.107,54.214h9.036V40.66a4.518,4.518,0,0,1,4.518-4.518H67.214V27.107H53.66a4.518,4.518,0,0,1-4.518-4.518V9.036H40.107V22.589a4.518,4.518,0,0,1-4.518,4.518H22.036v9.036H35.589a4.518,4.518,0,0,1,4.518,4.518Z",
    transform: "translate(761.684 674.053)",
    fill: "#1b3050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3965",
    "data-name": "\\uD328\\uC2A4 3965",
    d: "M4378.538,1131.641h18.877l-2.462-16.966h15.595l3.283,13.429,16.989,6.267-1.642,12.8-3.283,1.835-10.423,3.537-4.925,19.428h-15.595v-19.428s-18.877-2.328-18.877-3.537S4378.538,1131.641,4378.538,1131.641Z",
    transform: "translate(-3597.639 -436.076)",
    fill: "#1b3050"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c8848438a66c779f60cbb0ce0aac1973.svg";
export { ForwardRef as ReactComponent };